var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"none-data-container flex-center"},[_c('div',{staticClass:"none-wraper"},[(_vm.tipVal == '暂无数据')?_c('img',{attrs:{"src":require('../assets/images/no-dev-list.png')}}):_c('p',{staticClass:"font-18"},[_vm._v(_vm._s(_vm.tipVal))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-319c65e6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoneData.vue
// module id = null
// module chunks = 